import { Component, OnInit } from '@angular/core';
import { ImageTemplate } from 'src/app/models/image.model';
import { MessageService } from 'primeng/api';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.css']
})
export class TemplateListComponent implements OnInit {
  
  datasourceSelectTemplate: ImageTemplate[] = [];
  colsTablaTemplate: any[]; 
  loading: boolean = false;

  constructor(private messageService: MessageService,
      private imageService: ImageService) { }

  ngOnInit() {
      this.createColumnsTablaTemplates();
      this.populateTableTemplates();   
      this.imageService.removeModelEdit();
   }

  createColumnsTablaTemplates(){
      this.colsTablaTemplate = [
          { field: 'ID_TEMPLATE', header: 'ID', width: '10%'},
          { field: 'DESC_TYPES', header: 'Modelo Gift Card', width: '10%' },
          { field: 'RAZSOC_CLIENTE', header: 'Cliente', width: '20%' },
          { field: 'DESC_TEMPLATE', header: 'Descripción', width: '20%' },
          { field: 'IMG_MODELO_GIFT_CARD', header: 'Imagen Url', width: '30%' },
          { field: 'ESTADO', header: 'Estado', width: '10%' }
      ];
  }

  populateTableTemplates(){
      this.imageService.GetGiftCardTemplate().subscribe(
          (response: ImageTemplate[]) => {            
              this.datasourceSelectTemplate = response;    
              this.loading = false;   
          },
          (error) => {
              this.loading = false;
              this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar las plantillas.'});
          }
      )
  }

  editTemplate(template: ImageTemplate){
      this.imageService.setTemplateEdit(template);
  }

}
